import script from "./ProfileEditDialogs.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileEditDialogs.vue?vue&type=script&setup=true&lang=js"

import "./ProfileEditDialogs.vue?vue&type=style&index=0&id=67b4fe14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b4fe14"]])

export default __exports__